import React, { useContext, useState } from 'react'
import {
  IonContent,
  IonLabel,
  IonPage,
  IonSegment,
  IonSegmentButton,
  SegmentChangeEventDetail,
  useIonRouter,
  useIonViewWillEnter,
} from '@ionic/react'
import { StyleIonHeader } from '../../../components'
import { StoresContext } from '../../../provider/StoreProvider'
import { MainArtMuseum } from './MainArtMuseum'
import { MainEvent } from './MainEvent'
import { LIST_TYPE_ARTFAIR } from '../../../common'

interface IonSegmentCustomEvent<T> extends CustomEvent<T> {
  detail: T
  target: HTMLIonSegmentElement
}

export const Main: React.FC = () => {
  const { commonStore, authStore } = useContext(StoresContext)
  const [listType, setListType] = useState<LIST_TYPE_ARTFAIR>(LIST_TYPE_ARTFAIR.ART_MUSEUM)
  const router = useIonRouter()

  const onSegmentChange = (e: IonSegmentCustomEvent<SegmentChangeEventDetail>) => {
    if (e.target.value !== 'ART_MUSEUM' && e.target.value !== 'EVENT') {
      return
    }
    setListType(LIST_TYPE_ARTFAIR[e.target.value])
  }

  useIonViewWillEnter(() => {
    commonStore.setShowTab(true)
    // FIXME : route 또는 store에서 통합 처리할 수 있도록 수정 필요
    setTimeout(() => {
      if (authStore.userInfo?.status === 'NEED_REQUIRE_DATA_INPUT') {
        router.push('/signUp')
      }
    }, 300)
  })

  return (
    <IonPage>
      <StyleIonHeader type={'MAIN'} title={'ARTFAIR'} rightItem={'ALARM'} />
      <IonContent>
        <IonSegment color="dark" value={listType} onIonChange={(e) => onSegmentChange(e)}>
          <IonSegmentButton value="ART_MUSEUM">
            <IonLabel>아트뮤지엄</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="EVENT">
            <IonLabel>이벤트</IonLabel>
          </IonSegmentButton>
        </IonSegment>
        {listType === 'ART_MUSEUM' && <MainArtMuseum />}
        {listType === 'EVENT' && <MainEvent />}
      </IonContent>
    </IonPage>
  )
}
